/**
 * Single source of truth for joy-web's supported language codes.
 *
 * Lives in its own file so both `utils.ts` (i18next config, language detection
 * helpers) and `applyClosestSiblingResolver.ts` (the chain wrapper that needs
 * to know what the fallback terminus is) can import from it without forming a
 * circular dependency.
 *
 * Every code is an explicit BCP 47 lowercase-base + uppercase-region tag.
 * See `src/locales/README.md` for the procedure when adding a new language.
 */
export const LANGUAGES = {
  ENGLISH_BASE: 'en-US',
  ENGLISH_UK: 'en-GB',
  ENGLISH_AU: 'en-AU',
  SPANISH: 'es-ES',
  GERMAN: 'de-DE',
  FRENCH: 'fr-FR',
  ITALIAN: 'it-IT',
  JAPANESE: 'ja-JP',
};

export const SUPPORTED_LANGUAGE_CODES = Object.values(LANGUAGES);

export const DEFAULT_LANGUAGE = LANGUAGES.ENGLISH_BASE;

/**
 * Base language part of `DEFAULT_LANGUAGE`. Helpful for comparisons against
 * a region-stripped language code (e.g. `locale.language.split('-')[0]`)
 * where you want to ask "is this the default language family?" without
 * caring about the region tag.
 */
export const DEFAULT_LANGUAGE_BASE = DEFAULT_LANGUAGE.split('-')[0];
